import Layout from './src/layout';
import LayoutAside from './src/layout-aside';
import LayoutContent from './src/layout-content';
import LayoutHeader from './src/layout-header';
import LayoutFooter from './src/layout-footer';

const install = function(Vue) {
  Vue.component(Layout.name, Layout);
  Vue.component(LayoutAside.name, LayoutAside);
  Vue.component(LayoutContent.name, LayoutContent);
  Vue.component(LayoutHeader.name, LayoutHeader);
  Vue.component(LayoutFooter.name, LayoutFooter);
};

export default {
  install
};
